export const meta = {
  alias: 'before-and-after-slider',
  name: 'Before and After Slider'
};
